import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GanttShiftEndTimePipe } from './gantt-shift-end-time.pipe';
import { GanttShiftStartTimePipe } from './gantt-shift-start-time.pipe';
import { GanttActivityEndTimePipe } from './gantt-activity-end-time.pipe';
import { GanttActivityStartTimePipe } from './gantt-activity-start-time.pipe';
import { IsShiftDraggablePipe } from './is-shift-draggable.pipe';
import { DifferenceInMillisecondsPipe } from './difference-in-milliseconds.pipe';

@NgModule({
  declarations: [
    GanttShiftEndTimePipe,
    GanttShiftStartTimePipe,
    GanttActivityEndTimePipe,
    GanttActivityStartTimePipe,
    DifferenceInMillisecondsPipe,
    IsShiftDraggablePipe,
  ],
  imports: [CommonModule],
  exports: [
    GanttShiftEndTimePipe,
    GanttShiftStartTimePipe,
    GanttActivityEndTimePipe,
    GanttActivityStartTimePipe,
    DifferenceInMillisecondsPipe,
    IsShiftDraggablePipe,
  ],
})
export class ShiftTimelinePipesModule {}
